export const openExternalVaeLink = () => {
    window.open('https://www.sharelock.co/landing-page-assurance/wizzas ', "_self", 'noopener,noreferrer');
};

export default openExternalVaeLink
